<div class="content-holder">
    @if(config.actionHolder){
    <div class="name-holder">
        @for(i of getAbove(config.actionHolder.subHeadings); track i){
        <div class="group-name">
            @if(isString(i)){
            <p>{{i}}</p>
            }
            @else{
            <p>
                @for(v of getTextWithIcon(i); track v){
                @if(isIcon(v)){
                <i [ngClass]="v.clickable ? 'icon clickable-icon material-icons':'icon material-icons' "
                    (click)="v.action==undefined?undefined:v.action()">{{extractValue(v)}}</i>
                }@else {
                {{v}}
                }
                }
            </p>

            }
        </div>
        }
        <div class="router-name">
            @if(isString(config.actionHolder.heading)){
            <p>{{config.actionHolder.heading}}</p>
            }@else if(isDotted(config.actionHolder.heading)){
            <span class="dot" [style.background-color]="config.actionHolder.heading.dot"
                [matTooltip]="config.actionHolder.heading.tooltip" matTooltipClass="my-cust">
            </span>
            @if(isString(config.actionHolder.heading.value)){
            <p>{{config.actionHolder.heading.value}}</p>
            }@else{
            <p>
                @for(v of getTextWithIcon(config.actionHolder.heading.value); track v){
                @if(isIcon(v)){
                &nbsp;<i [ngClass]="v.clickable ? 'icon clickable-icon material-icons':'icon material-icons' "
                    (click)="v.action==undefined?undefined:v.action()">{{extractValue(v)}}</i>
                }@else {
                {{v}}
                }
                }
            </p>
            }
            }@else {
            <p>
                @for(v of getTextWithIcon(config.actionHolder.heading); track v){
                @if(isIcon(v)){
                <i [ngClass]="v.clickable ? 'icon clickable-icon material-icons':'icon material-icons' "
                    (click)="v.action==undefined?undefined:v.action()">{{extractValue(v)}}</i>
                }@else {
                {{v}}
                }
                }
            </p>
            }

        </div>
        @for(i of getBelow(config.actionHolder.subHeadings); track i){
        <div class="group-name">
            @if(isString(i)){
            <p>{{i}}</p>
            }
            @else{
            <p>

                @for(v of getTextWithIcon(i); track v){
                @if(isIcon(v)){
                <i [ngClass]="v.clickable ? 'icon clickable-icon material-icons':'icon material-icons' "
                    (click)="v.action==undefined?undefined:v.action()">{{extractValue(v)}}</i>
                }@else {
                {{v}}
                }
                }
            </p>

            }
        </div>
        }
        @if(config.actionHolder.buttons)
        { <div class="buttons">
            @for(btn of config.actionHolder.buttons; track btn)
            {

            @if (isBreak(btn)){
            <span class="break"></span>
            }
            @else if(isButton(btn)){
                @if(btn.visible){
                    @if(btn.tooltip){
                    <button mat-icon-button class="button" [matTooltip]="btn.tooltip" (click)="btn.action()">
                        <mat-icon>{{btn.icon}}</mat-icon>
                    </button>
                    }@else{
                    <button mat-icon-button class="button" (click)="btn.action()">
                        <mat-icon>{{btn.icon}}</mat-icon>
                    </button>
                }
            }
            }@else {
            <button mat-button class="dropdown-button" [matMenuTriggerFor]="menu">{{btn.title}}</button>
            <mat-menu #menu="matMenu">
                @for(option of btn.options;track option){
                <button mat-menu-item (click)="option.action()">{{option.text}}</button>
                }
            </mat-menu>
            }
            }
        </div>
        }
    </div>
    }
    <div class="details-holder">
        <div class="details-portions">
            @for(i of (config.details|keyvalue); track i){
            <div class="details">

                <div class="details-title">
                    {{i.key}}:
                </div>
                <div class="details-data">

                    @for(j of (i.value|keyvalue:orderFunction(config.OrderFunctions,i.key)); track j){

                    <div class="details-data-row">
                        @if(isBreak(j.value)){
                        <div class="data-break"></div>
                        }@else{
                        <div class="data-title"><span class="title" (mouseover)="showData($event, j.value)"
                                (mouseleave)="hideData($event, j.value)">{{j.key}}</span>
                        </div>
                        @if(j.value == null){
                        <div class="data-value">
                            <span class="value">
                                -
                            </span>
                        </div>
                        }@else if(isString(j.value)){
                        <div class="data-value">
                            <span class="value" (mouseover)="showData($event, j.value)" (mouseleave)="hideData($event, j.value)">
                                {{j.value}}
                            </span>
                        </div>
                        }@else if(isNumber(j.value)){
                        <div class="data-value">
                            <span class="value" (mouseover)="showData($event, j.value)" (mouseleave)="hideData($event, j.value)">
                                {{j.value}}
                            </span>
                        </div>
                        }
                        @else if(isLayered(j.value.value)){
                        <div class="layered-data-value">
                            @if(j.value.dot!==undefined){
                            <span class="dot" [style.background-color]="j.value.dot" class="dot">
                            </span>
                            }
                            <div class="values">
                                @if(j.value.value.topText){
                                <span class="top-text">{{j.value.value.topText}}</span>
                                }
                                @if(j.value.value.middleText){
                                <span class="middle-text">{{j.value.value.middleText}}</span>
                                }
                                @if(j.value.value.bottomText){
                                <span class="bottom-text">{{j.value.value.bottomText}}</span>
                                }
                            </div>
                        </div>

                        }
                        @else if(j.value.image===true){
                        <div class="image-data-value">
                            @for(k of getImages(j.value.value); track k){
                            <div class="image-container">
                                @if(k.popover){
                                <img src={{k.path}} [ngStyle]="{height:k.height??'auto',width:k.width??'auto'}"
                                    alt="image" (click)="showPopover($event, k, getImages(j.value.value))">
                                @if(k.displayPopover!=null && k.displayPopover){
                                <div [ngClass]="k.popoverSide==='left'?'popover-left':'popover-right'">
                                    @for(l of k.popover;track l){
                                    @if(isHeading(l)){
                                    @if(isString(l.heading)){
                                    <h1 style="font-size: 20px; font-family: 'Times New Roman', Times, serif;">
                                        {{l.heading}}
                                    </h1>
                                    }@else{
                                    <h1 style="font-size: 20px; font-family: 'Times New Roman', Times, serif;">
                                        @for (data of l.heading; track data){
                                        @if(isString(data)){
                                        {{data}}
                                        }@else{
                                        <img src={{data.path}}
                                            [ngStyle]="{height:data.height??'auto',width:data.width??'auto'}"
                                            alt="image">
                                        }
                                        }
                                    </h1>
                                    }
                                    }
                                    @else if(isSubheading(l)){
                                    @if(isString(l.subheading)){
                                    <h2 style="font-size: 16px; font-family: 'Times New Roman', Times, serif;">
                                        {{l.subheading}}</h2>
                                    }@else {
                                    <h2 style="font-size: 16px; font-family: 'Times New Roman', Times, serif;">
                                        @for (data of l.subheading; track data){
                                        @if(isString(data)){
                                        {{data}}
                                        }@else{
                                        <img src={{data.path}}
                                            [ngStyle]="{height:data.height??'auto',width:data.width??'auto'}"
                                            alt="image">
                                        }
                                        }
                                    </h2>
                                    }
                                    }
                                    @else if(isButton(l)){
                                      @if(l.icon !== undefined){
                                        <button mat-button
                                                class="popover-button-icon"
                                                matTooltip="Go to device details"
                                                matTooltipPosition="above"
                                                (click)="l.action()">
                                          <mat-icon class="icon">{{ l.icon }}</mat-icon>
                                        </button>

                                      } @else {
                                        <button mat-button class="popover-button" (click)="l.action()"> {{l.text}} </button>
                                      }
                                    }@else if(isPopoverDataObject(l)){
                                    @for(m of (l|keyvalue);track m){
                                    @if (isString(m.value)){
                                    <span class="popover-data">
                                        <p>{{m.key}}</p>
                                        <p>{{m.value}}</p>
                                    </span>
                                    }@else if(isArray(m.value)){
                                    <span class="popover-data">
                                        <p>{{m.key}}</p>
                                        @for (popoverVal of m.value; track popoverVal){
                                        @if(isString(popoverVal)){
                                        <p>{{popoverVal}}</p>
                                        }@else if(isImage(popoverVal)){
                                        <img src={{k.path}} [ngStyle]="{height:k.height??'auto',width:k.width??'auto'}"
                                            alt="image">
                                        }
                                        }
                                    </span>
                                    }
                                    }
                                    }
                                    }
                                </div>

                                }
                                }@else{
                                <img src={{k.path}} [ngStyle]="{height:k.height??'auto',width:k.width??'auto'}"
                                    alt="image">
                                }
                            </div>
                            }
                        </div>
                        }@else {
                        <div class="data-value">
                            @if(j.value.dot!==undefined){
                            <span class="dot" [style.background-color]="j.value.dot" class="dot">
                            </span>
                            }
                            @if(isString(j.value.value)){
                            <span class="value" (mouseover)="showData($event, j.value)" (mouseleave)="hideData($event, j.value)">
                                <!-- {{j.value.value}} -->
                                {{ isObjectWithCurrentValue(j.value) ? j.value.currentValue : j.value.value }}
                            </span>
                            }@else if(isNumber(j.value.value)){
                            <span class="value" (mouseover)="showData($event, j.value)" (mouseleave)="hideData($event, j.value)">
                                {{j.value.value}}
                            </span>
                            }
                            @else{
                            @for(k of getTextWithIcon(j.value.value); track k){
                            @if(isIcon(k)){
                            <i [ngClass]="k.clickable ? 'icon clickable-icon material-icons':'icon material-icons' "
                                (click)="k.action==undefined?undefined:k.action()">{{extractValue(k)}}</i>
                            }@else {
                            <span class="value">{{k}}</span>

                            }
                            }
                            }
                        </div>

                        }
                        }
                    </div>
                    }
                </div>
            </div>

            }

        </div>
    </div>
